"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var VButton_vue_1 = __importDefault(require("../scraps/VButton.vue"));
var VIcon_vue_1 = __importDefault(require("../scraps/VIcon.vue"));
var uuid_1 = require("uuid");
var __ = window.$lang;
var DropdownSelect = /** @class */ (function (_super) {
    __extends(DropdownSelect, _super);
    function DropdownSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "dropdown-select";
        return _this;
    }
    DropdownSelect.prototype.getCurrentOption = function () {
        return this.currentOption.value
            ? this.currentOption
            : this.defaultOption;
    };
    DropdownSelect.prototype.onOptionClick = function (option) {
        if (option.value !== this.currentOption.value) {
            this.$emit("change", option);
        }
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: "dropdown-select-" + uuid_1.v4() })
    ], DropdownSelect.prototype, "id", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: function () {
                return {
                    value: 0,
                    name: __("Wybierz opcję")
                };
            } })
    ], DropdownSelect.prototype, "defaultOption", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], DropdownSelect.prototype, "currentOption", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], DropdownSelect.prototype, "options", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: "" })
    ], DropdownSelect.prototype, "optionDescription", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: "" })
    ], DropdownSelect.prototype, "icon", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false })
    ], DropdownSelect.prototype, "displayLoading", void 0);
    DropdownSelect = __decorate([
        vue_property_decorator_1.Component({ components: {
                VButton: VButton_vue_1.default,
                VIcon: VIcon_vue_1.default
            } })
    ], DropdownSelect);
    return DropdownSelect;
}(vue_1.default));
exports.default = DropdownSelect;
